import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { apiEndpoint } from 'configs'

export const loginNewApiSlice = createApi({
  reducerPath: 'login-new/api',
  baseQuery: fetchBaseQuery({
    baseUrl: apiEndpoint,
    prepareHeaders: (headers, { getState }) => {
      const { auth } = getState()
      if (auth?.token) {
        headers.set('Authorization', `Bearer ${auth?.token}`)
      }
      return headers
    },
  }),
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    loginUserNew: builder.mutation({
      query: (payload) => ({
        url: `/api/v3/public/authentication/login`,
        method: 'POST',
        body: payload,
        headers: {
          Authorization: 'cG1iUFVCc2VjcmVjdDoyMDI1',
        },
      }),
      transformResponse: (response, _meta, arg) => {
        const newData = response?.data?.abilityRole?.map((obj) => {
          const newItem = { ...obj, subject: obj.subjects }
          delete newItem?.subjects
          delete newItem?.fields
          delete newItem?.conditions
          return newItem
        })

        return {
          ...response?.data,
          abilityRole: newData,
          token: response?.data?.api_token,
        }
      },
    }),
    precheckLogin: builder.mutation({
      query: (payload) => ({
        url: `/api/v3/public/authentication/check`,
        method: 'POST',
        body: payload,
        headers: {
          Authorization: 'cG1iUFVCc2VjcmVjdDoyMDI1',
        },
      }),
    }),
    checkDeviceV1: builder.query({
      query: ({ deviceHash }) => ({
        url: `/api/v1/public/device/check`,
        method: 'GET',
        params: { deviceHash },
      }),
    }),
    checkDeviceV2: builder.mutation({
      query: (payload) => ({
        url: `/api/v3/public/device/check`,
        method: 'POST',
        body: payload,
        headers: {
          Authorization: 'cG1iUFVCc2VjcmVjdDoyMDI1',
        },
      }),
    }),
    createDevice: builder.mutation({
      query: (payload) => ({
        url: `/api/v3/public/device`,
        method: 'POST',
        body: payload,
        headers: {
          Authorization: 'cG1iUFVCc2VjcmVjdDoyMDI1',
        },
      }),
    }),
    sendOtpLogin: builder.mutation({
      query: (payload) => ({
        url: `/api/v3/public/authentication/otp/send`,
        method: 'POST',
        body: payload,
        headers: {
          Authorization: 'cG1iUFVCc2VjcmVjdDoyMDI1',
        },
      }),
    }),
    verifyOtpLogin: builder.mutation({
      query: (payload) => ({
        url: `/api/v3/public/authentication/otp/verify`,
        method: 'POST',
        body: payload,
        headers: {
          Authorization: 'cG1iUFVCc2VjcmVjdDoyMDI1',
        },
      }),
    }),
    getVersion: builder.query({
      query: () => `/api/v1/public/version`,
      transformResponse(response, meta, arg) {
        return response
      },
    }),
    checkPassword: builder.mutation({
      query: (payload) => ({
        url: `/api/v3/public/authentication/check-password`,
        method: 'POST',
        body: payload,
        headers: {
          Authorization: 'cG1iUFVCc2VjcmVjdDoyMDI1',
        },
      }),
    }),
    resetPassword: builder.mutation({
      query: (payload) => ({
        url: `/api/v3/public/authentication/reset-password`,
        method: 'POST',
        body: payload,
        headers: {
          Authorization: 'cG1iUFVCc2VjcmVjdDoyMDI1',
        },
      }),
    }),
    sendPinOtp: builder.mutation({
      query: (payload) => ({
        url: `/api/v1/bussines/sendotp`,
        method: 'POST',
        body: payload,
      }),
    }),
    verifyPINOtp: builder.mutation({
      query: (payload) => ({
        url: `/api/v1/bussines/verifyotp`,
        method: 'POST',
        body: payload,
      }),
    }),
    resetPin: builder.mutation({
      query: (payload) => ({
        url: `/api/v1/bussines/resetpin`,
        method: 'POST',
        body: payload,
      }),
    }),
    updatePassword: builder.mutation({
      query: (payload) => ({
        url: `/api/v3/public/authentication/update-password`,
        method: 'POST',
        body: payload,
        headers: {
          Authorization: 'cG1iUFVCc2VjcmVjdDoyMDI1',
        },
      }),
    }),
    checkDeviceWa: builder.mutation({
      query: (payload) => ({
        url: `/api/v1/public-whatsapp/device-check`,
        method: 'POST',
        body: payload,
        headers: {
          Authorization: 'cG1iUFVCc2VjcmVjdDoyMDI1',
        },
      }),
    }),
    createDeviceWa: builder.mutation({
      query: (payload) => ({
        url: `/api/v1/public-whatsapp/device-create`,
        method: 'POST',
        body: payload,
        headers: {
          Authorization: 'cG1iUFVCc2VjcmVjdDoyMDI1',
        },
      }),
    }),
    loginWa: builder.mutation({
      query: (payload) => ({
        url: `/api/v1/public-whatsapp/login`,
        method: 'POST',
        body: payload,
        headers: {
          Authorization: 'cG1iUFVCc2VjcmVjdDoyMDI1',
        },
      }),
      transformResponse: (response, _meta, arg) => {
        const newData = response?.data?.abilityRole?.map((obj) => {
          const newItem = { ...obj, subject: obj.subjects }
          delete newItem?.subjects
          delete newItem?.fields
          delete newItem?.conditions
          return newItem
        })

        return {
          ...response?.data,
          abilityRole: newData,
          token: response?.data?.api_token,
        }
      },
    }),
  }),
})

export const {
  useLoginUserNewMutation,
  usePrecheckLoginMutation,
  useCreateDeviceMutation,
  useSendOtpLoginMutation,
  useVerifyOtpLoginMutation,
  useLazyCheckDeviceV1Query,
  useCheckDeviceV2Mutation,
  useGetVersionQuery,
  useCheckPasswordMutation,
  useResetPasswordMutation,
  useUpdatePasswordMutation,
  useSendPinOtpMutation,
  useVerifyPINOtpMutation,
  useResetPinMutation,
  useCheckDeviceWaMutation,
  useCreateDeviceWaMutation,
  useLoginWaMutation,
} = loginNewApiSlice
